module.exports = __webpack_public_path__ + "img/LOGO_VAMPIRO_V3.80256dd8.png";